import { useRef } from 'react';
import { ErrorBoundary } from '@servicetitan/financing-utils-shared';
import {
    ApplicantContainer,
    ApplicationDataStore,
    CoApplicantContainer,
    DisclosureDataStore,
    DisclosuresContainer,
    MailingAddressContainer,
    ReviewContainer,
    ServicePropertyContainer,
    ImperativeForm,
} from '@servicetitan/financing-application-shared';
import { WorkflowStore } from '@servicetitan/financing-workflow-shared';
import { applicationPanel } from './ApplicationWorkflow.module.scss';
import { StepperLayout } from '../layout';
import { ApplicationButtons } from './ApplicationButtons';

export function ApplicationWorkflow() {
    const { setWorkflowStage } = WorkflowStore.useStore();
    const { disclosureState } = DisclosureDataStore.useStore();
    const { agreedToDisclosures } = disclosureState;
    const { isEditing } = ApplicationDataStore.useStore();
    const formRef = useRef<ImperativeForm>(null);

    const steps = [
        {
            name: 'applicant',
            label: 'Applicant',
            panelClassName: applicationPanel,
            panelComponent: <ApplicantContainer formRef={formRef} />,
            buttonsComponent: <ApplicationButtons formRef={formRef} showBackToPlanSelection />,
        },
        {
            name: 'mailing-address',
            label: 'Mailing Address',
            panelClassName: applicationPanel,
            panelComponent: <MailingAddressContainer formRef={formRef} />,
        },
        {
            name: 'service-property',
            label: 'Service Property',
            panelClassName: applicationPanel,
            panelComponent: (
                <ErrorBoundary actionCausingError="loading improvement types">
                    <ServicePropertyContainer formRef={formRef} />
                </ErrorBoundary>
            ),
        },
        {
            name: 'co-applicant',
            label: 'Co-applicant',
            panelClassName: applicationPanel,
            panelComponent: <CoApplicantContainer formRef={formRef} />,
        },
        {
            name: 'review',
            label: 'Review',
            panelClassName: applicationPanel,
            panelComponent: <ReviewContainer />,
            buttonsComponent: (
                <ApplicationButtons formRef={formRef} isNextButtonDisabled={isEditing} />
            ),
        },
        {
            name: 'disclosures',
            label: 'Disclosures',
            panelClassName: applicationPanel,
            panelComponent: <DisclosuresContainer />,
            buttonsComponent: (
                <ApplicationButtons formRef={formRef} isNextButtonDisabled={!agreedToDisclosures} />
            ),
        },
    ];

    return (
        <StepperLayout
            onComplete={() => setWorkflowStage('submitting')}
            buttonsComponent={<ApplicationButtons formRef={formRef} />}
            steps={steps}
        />
    );
}
